import CartActivityItem from "../cart-activity-item/CartActivityItem";
import './BasketComp.css'
import { useDispatch, useSelector } from "react-redux";
import {
    setActivityDate,
    setActivityEditMode,
    setApiIcreditGetURL,
    setColumnMessage,
    setCurrentStep,
    setIsStepFourLoading,
    setPaymentCountDown,
    setSelectedActivity,
    setVisitors,
    setCartTotalSum,
    setCartDiscountAmount,
    setCustomerFormErrors,
    setCustomerDetails,
    setSteps,
    setCreateMode,
    setFlowType
} from "../../store/MahutiReducer";
import { ConnectToIcredit } from "../../utils/api";
import { useLocation, useNavigate } from "react-router-dom";
import { patchOpportunitySF } from "../../utils/sfUtils";
import { FLOW_TYPE, PAGES, PATCH_OPPORTUNITY_ERR_MSG, PAYMENT_IN_PROCESS, PAYMENT_TIME_OUT_MINS, PREFIX_PATH } from "../../utils/GlobalParams";
import { useEffect, useState } from "react";
import {mySteps, myStepsActivity, myStepsActivityMOBILE, myStepsMOBILE} from "../../utils/stepperUtils";
import { LocalStorageKEYS, setLocalStorage } from "../../store/mahutiLocalStorage";
import { calculateCountDownSeconds } from "../../utils/orderUtils";
import { isMobile } from "react-device-detect";

export default function BasketComp(props) {

    const store = useSelector(state => state.reducer);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const [isLoadingICredit, setIsLoadingICredit] = useState(undefined)

    const classUnused = store.selectedActivities.length === 0 ? ' unused-component' : ''
    const anotherShopping = (e) => {

        if (store.selectedActivities.length === 0 || store.isStepFourLoading) {

        }
        else {
            e.preventDefault();
            dispatch(setPaymentCountDown({ status: 'Pending', timer: calculateCountDownSeconds(false, true, store) }));
            dispatch(setCurrentStep(0));
            dispatch(setSelectedActivity(undefined));
            dispatch(setVisitors({ adults: 1, underAge: 1 }));
            dispatch(setActivityDate(undefined));
            dispatch(setActivityEditMode(undefined));
            dispatch(setIsStepFourLoading(undefined));
            dispatch(setColumnMessage())
            let lpPrefix = store.lpName ? '/' + store.lpName : '';
            navigate(PREFIX_PATH + lpPrefix + '/');

        }

    }

    const goPay = (e) => {
        e.preventDefault()
        setIsLoadingICredit(true);
        let minutes = calculateCountDownSeconds(true, true, store)
        dispatch(setPaymentCountDown({ status: 'Pending', timer: minutes }));
        patchOpportunitySF(undefined, store.opportunity.id, PAYMENT_IN_PROCESS, store.customerDetails, false) 
        .then(res => {
            ConnectToIcredit(dispatch, navigate, store).then(res => {
                if (res.status === 200) {
                    dispatch(setApiIcreditGetURL(res.data));

                    dispatch(setCreateMode(false))
                    dispatch(setFlowType(FLOW_TYPE.DATE_FLOW))
                    let steps = isMobile ? myStepsMOBILE : mySteps
                    dispatch(setSteps(steps))

                    setIsLoadingICredit(false);
                    let lpPrefix = store.lpName ? '/' + store.lpName : '';
                    navigate(PREFIX_PATH + lpPrefix + '/' + PAGES.PAYMENT_PAGE)
                }
            });
        })
        .catch(err => {
            dispatch(setColumnMessage({...store.columnMessage, alert: PATCH_OPPORTUNITY_ERR_MSG}))
            setIsLoadingICredit(false);
        })

    }

    const goToPaymenyStepFour = (e) => {
        dispatch(setCreateMode(false))
        const flowType = store.flowType ? store.flowType : false;
        let lpPrefix = store.lpName ? '/' + store.lpName : '';
        if(flowType === FLOW_TYPE.DATE_FLOW) {
            navigate(PREFIX_PATH + lpPrefix + '/' + PAGES.DATE_FLOW);
            const lastStep = mySteps.length - 1;
            dispatch(setCurrentStep(lastStep));
        }else{ 
            navigate(PREFIX_PATH + lpPrefix + '/' + PAGES.ACTIVITY_FLOW);
            let steps = isMobile ? myStepsActivityMOBILE : myStepsActivity
            dispatch(setSteps(steps))
            const lastStep = steps.length - 1;
            dispatch(setCurrentStep(lastStep));
        }
    }

    const isLastStep = store && store.currentStep === store.steps.length - 1 && store.selectedActivities.length;
    const isExistActivities = store.selectedActivities.length
    const isDisable = (store.isStepFourLoading
        || isLoadingICredit === true
        || store.selectedActivities.length === 0
    )

    const localCartTotalSumCalc = () => {
        let totalSum = 0
        if(store.selectedActivities.length > 0){
            store.selectedActivities.map((item) => {
                if(item.price && item.visitors){
                    totalSum += (item.price.underAge * item.visitors.underAge) + (item.price.adults * item.visitors.adults)
                }
            })
        }
        if(store.cartDiscountRate > 0){
            dispatch(setCartTotalSum(totalSum - (totalSum * store.cartDiscountRate/100)))
            dispatch(setCartDiscountAmount(totalSum * store.cartDiscountRate/100))
        }else{
            dispatch(setCartTotalSum(totalSum))
            dispatch(setCartDiscountAmount(0))
        }
    }

    const validateForm = (submitClick = false) => {
        let errors = {}
        let formIsValid = true
        let customerNewObj = store.customerDetails

        if(('firstName' in customerNewObj && 
        !customerNewObj.firstName) || submitClick){ 
            if(!customerNewObj.firstName){
                formIsValid = false;
                customerNewObj = {...customerNewObj, firstName: ''};
                errors.firstName = "שדה חובה";
            }
        }
        
        if(('lastName' in customerNewObj && 
        !customerNewObj.lastName) || submitClick){ 
            if(!customerNewObj.lastName){
                formIsValid = false; 
                errors.lastName = "שדה חובה"
                !customerNewObj.lastName && (customerNewObj = {...customerNewObj, lastName: ''})
            }
        }
        
        let phoneTest = /^\+?(972|0)(\-)?0?(([23489]{1}\d{7})|[5]{1}\d{8})$/;
        if(('phoneNumber' in customerNewObj && 
        !(phoneTest).test(customerNewObj.phoneNumber)) || 
        submitClick){ 
            if(!(phoneTest).test(customerNewObj.phoneNumber)){
                formIsValid = false; 
                errors.phoneNumber = "טלפון לא חוקי"
                !customerNewObj.phoneNumber && (customerNewObj = {...customerNewObj, phoneNumber: ''})
            }
        }

        let emailTest = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;
        if(('email' in customerNewObj && 
        !(emailTest).test((customerNewObj.email).toLowerCase())) ||
        submitClick){ 
            if(!(emailTest).test(customerNewObj.email)){
                formIsValid = false; 
                errors.email = "אימייל לא תקין"
                !customerNewObj.email && (customerNewObj = {...customerNewObj, email: ''})
            }
        }

        if(('city' in customerNewObj && 
        !customerNewObj.city) || submitClick){ 
            if(!customerNewObj.city){
                formIsValid = false; 
                errors.city = "שדה חובה"
                !customerNewObj.city && (customerNewObj = {...customerNewObj, city: ''})
            }
        }

        if(('approvingCondition' in customerNewObj && 
        !customerNewObj.approvingCondition) || submitClick){ 
            if(!customerNewObj.approvingCondition){
                formIsValid = false; 
                errors.approvingCondition = "חובה להסכים לתנאי השימוש"
                !customerNewObj.approvingCondition && (customerNewObj = {...customerNewObj, approvingCondition: ''})
            }
        }

        if(submitClick){
            dispatch(setCustomerDetails(customerNewObj));
            for (var key in errors) {
                if (errors.hasOwnProperty(key)) {
                    document.getElementById(`${key}_scroll`).scrollIntoView();
                    break;
                }
            }
        }
        dispatch(setCustomerFormErrors(errors))
        return formIsValid
    }

    useEffect(() => {
        validateForm()
    },[store.customerDetails])

    useEffect(() => {
        localCartTotalSumCalc()
    },[store.selectedActivities, store.cartDiscountRate])

    return <>{(!props.isFloating && !isMobile) && <h4 className="text-start cart_title mb-4 almoni_tzar_normal">{store.selectedActivities.length || 0} פעילויות נבחרו:</h4>}
            <div className={"basketComp p-3 pt-lg-4 px-lg-1 pb-lg-1" + (props.isFloating ? ' floating' : '')}>
                <div className={`py-lg-1 ${isMobile ? 'inner_basket' : 'container'}`}>
                    {(props.isFloating || isMobile) && <h5 className="text-start px-lg-2 header-cover-title py-2 almoni_tzar_bold">{store.selectedActivities.length || 0} פעילויות נבחרו:</h5>}
                    <ul className="list-group">
                        {store.selectedActivities.map((item, index) => <li key={'cartItem.' + (item?.campainId || index)} className="px-lg-1 pt-2 pt-lg-4 pb-3 p-lg-1 border-0"><CartActivityItem index={index}
                            isDisable={isExistActivities && store.isStepFourLoading} {...item} dispatch={dispatch} store={store} /></li>)}

                        <li className={"p-lg-1 mt-lg-2 border-0 bg-white" + classUnused} >
                            <div className="p-lg-2">
                                <div className={`${!isMobile ? 'container' : ''}`}>
                                    <div className="paymentDetalis text-end pb-3 pt-0 py-lg-3">
                                        <span id='payment-copon' className="text-mahuti">הטבת קופון: ({store.cartDiscountAmount || '-- '}₪)</span> {/* store.opportunity?.discount */}
                                        <span id='overall-sum' className="text-mahuti">
                                            סה”כ: {`${store.cartTotalSum || '0 '}₪`} {/* store.opportunity?.amount */}
                                        </span>
                                    </div>
                                    <div id='routeToPay' className="d-flex align-items-center justify-content-between">
                                        <button className={`col btn-link bg-body border-0 ${isMobile ? 'almoni_tzar_bold' : 'almoni_tzar_normal'}`} onClick={(e) => anotherShopping(e)}
                                            disabled={store.selectedActivities.length === 0 || store.isStepFourLoading || !isLastStep}>{store.lpParams.Extra_Purchase_Title__c || 'לביצוע רכישה נוספת'}</button>

                                        {/* (isLastStep && isDisable ? 'btn-disabled' : '') */}
                                        <button className={"col card-title-light btn-primary"} 
                                            disabled={isLastStep && isDisable}
                                            data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-title={store.selectedActivities ? "you must Fill required Data" : ''}
                                            onClick={isLastStep ? (e) => {validateForm(true) && goPay(e)} : (e) => isExistActivities ? goToPaymenyStepFour(e) : null}>
                                            <span>לתשלום</span>
                                            {(isLoadingICredit || store.isStepFourLoading) && <span className="spinner-border spinner-border-sm ms-2" role="status" aria-hidden="true"></span>}</button>
                                    </div>

                                </div>

                            </div>

                        </li>
                    </ul>
                    <div className="text-start header-cover-title py-1" />
                </div>
            </div></>
} 